export default __webpack_public_path__ + "static/media/Golden Knights.014901f0.png";